module.exports = __webpack_public_path__ + "img/icon_arrow_left.7a6159fc.svg";